import { render, staticRenderFns } from "./AdminSettingSharedAccount.vue?vue&type=template&id=2328aebc&scoped=true&"
import script from "./AdminSettingSharedAccount.vue?vue&type=script&lang=js&"
export * from "./AdminSettingSharedAccount.vue?vue&type=script&lang=js&"
import style0 from "./AdminSettingSharedAccount.vue?vue&type=style&index=0&id=2328aebc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2328aebc",
  null
  
)

export default component.exports